/**
 * Stellar · effet terminal DOS (typewriter)
 */
(function () {
  'use strict';

  var DOS_CHAR_MS = 48;
  var DOS_START_DELAY = 280;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initDosTypewriters(root) {
    (root || document).querySelectorAll('[data-dos-type]').forEach(function (el) {
      if (el.dataset.dosInit === 'true') return;
      el.dataset.dosInit = 'true';

      var text = el.getAttribute('data-dos-text') || '';
      var out = el.querySelector('[data-dos-out]');
      if (!out || !text) return;

      var timer = null;
      var idx = 0;
      var reduced = prefersReducedMotion();
      var autostart = el.hasAttribute('data-dos-autostart');
      var card = el.closest('[data-realisation-card]');

      function clearTimer() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      function reset() {
        clearTimer();
        idx = 0;
        out.textContent = '';
        el.classList.remove('is-typing', 'is-done');
      }

      function finish() {
        clearTimer();
        el.classList.remove('is-typing');
        el.classList.add('is-done');
      }

      function typeStep() {
        if (idx >= text.length) {
          finish();
          return;
        }
        out.textContent += text.charAt(idx);
        idx += 1;
        timer = setTimeout(typeStep, DOS_CHAR_MS);
      }

      function start() {
        if (reduced) {
          out.textContent = text;
          el.classList.add('is-done');
          return;
        }
        reset();
        el.classList.add('is-typing');
        timer = setTimeout(typeStep, DOS_START_DELAY);
      }

      if (autostart) {
        start();
        return;
      }

      if (el.hasAttribute('data-dos-inview') && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              start();
              observer.unobserve(el);
            });
          },
          { threshold: 0.45, rootMargin: '0px 0px -8% 0px' }
        );
        observer.observe(el);
        return;
      }

      if (card) {
        card.addEventListener('mouseenter', start);
        card.addEventListener('mouseleave', function () {
          if (!reduced) reset();
        });
      }
    });
  }

  function boot() {
    initDosTypewriters(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-dos-type]').forEach(function (el) {
      delete el.dataset.dosInit;
    });
    initDosTypewriters(event.target);
  });

  window.StellarDosType = { init: initDosTypewriters };
})();
